import { Popover } from "flowbite-react";
import { Bell } from "lucide-react";
import { NotificationDropdown } from "@/features/notifications/components/NotificationDropdown";
import { useNotificationsContext } from "@/features/notifications/context/NotificationsContext";
import { SidebarMobileButton } from "@/shared/components/ui/sidebar-mobile-button";

export const NotificationMobileToggle = () => {
  const { totalCount } = useNotificationsContext();

  return (
    <Popover
      aria-labelledby="notification-mobile-popover"
      content={<NotificationDropdown />}
      trigger="click"
      placement="bottom-end"
    >
      <SidebarMobileButton className="px-4 py-2">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            <Bell size={20} />
            <span className="text-xs font-medium">
              Notifications
            </span>
          </div>
          {totalCount > 0 && (
            <span className="flex items-center justify-center min-w-5 h-5 px-1.5 text-xs font-bold text-white bg-error rounded-full">
              {totalCount > 99 ? "99+" : totalCount}
            </span>
          )}
        </div>
      </SidebarMobileButton>
    </Popover>
  );
};
